// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* === Backdrop === */
.tmatrix-modal-backdrop-filter {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  backdrop-filter: blur(6px);
}

/* === Modal Content === */
.tmatrix-modal-content-filter {
  display: flex;
  flex-direction: column;
  background-color: #ffffff;
  padding: 32px;
  border-radius: 12px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);
  width: 90%;
  max-width: 640px;
  position: relative;
  transition: transform 0.3s ease, opacity 0.3s ease;
  animation: fadeIn 0.3s ease-in-out;
  opacity: 1;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(-20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* === Select List === */
.list-select-filter {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  align-items: center;
  margin-bottom: 20px;
}



/* === Buttons === */
.button-close-filter {
  background-color: #cbb9af;
  color: #ffffff;
  border: none;
  padding: 12px 24px;
  border-radius: 8px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 600;
  transition: background-color 0.3s ease, transform 0.2s ease;
  flex: 1 1;
  text-align: center;
}

.button-close-filter:hover {
  background-color: #a8907e;
  transform: scale(1.05);
}

.button-add {
  background-color: #94d3a2;
  color: #fff;
  border: none;
  padding: 12px 24px;
  border-radius: 8px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 600;
  transition: background-color 0.3s ease, transform 0.2s ease;
  flex: 0.5 1;
  text-align: center;
}

.button-add:hover {
  background-color: #7db88a;
  transform: scale(1.05);
}

/* === Inputs === */
.input-menu-filter {
  width: 220px;
  padding: 12px;
  border: 1px solid #ccc;
  border-radius: 6px;
  font-size: 16px;
  outline: none;
  box-sizing: border-box;
  flex: 2 1;
  transition: border-color 0.3s, box-shadow 0.3s;
}

.input-menu-filter:focus {
  border-color: #94d3a2;
  box-shadow: 0 0 8px rgba(148, 211, 162, 0.4);
}

/* === Parameter List Section === */
.modal-content-filter h3 {
  font-size: 20px;
  font-weight: 600;
  margin-bottom: 15px;
  color: #2d3748;
}

.modal-content-filter ul {
  list-style: none;
  padding: 0;
  margin: 0;
  text-align: left;
}

.modal-content-filter li {
  background: #f0f2f5;
  padding: 10px;
  margin: 6px 0;
  border-radius: 6px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.modal-content-filter input[type="text"] {
  width: 48%;
  padding: 8px;
  border: 1px solid #ccc;
  border-radius: 4px;
  font-size: 14px;
  text-align: center;
}

.modal-content-filter button {
  margin-top: 15px;
  padding: 10px 15px;
  background: #7490c7;
  color: white;
  border: none;
  border-radius: 6px;
  font-size: 14px;
  cursor: pointer;
  transition: background 0.3s ease, transform 0.2s ease;
}

.modal-content-filter button:hover {
  background: #5d78a6;
  transform: scale(1.05);
}

.modal-content-filter button:active {
  background: #4b6088;
  transform: scale(0.98);
}

.modal-content-filter button:not(:last-child) {
  margin-right: 10px;
}

/* === Range Section === */
.range-container {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  padding: 1.2rem;
  margin-bottom: 1.5rem;
  border-radius: 10px;
  background-color: #ffffff;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  max-width: 400px;
  width: 100%;
  font-family: 'Segoe UI', sans-serif;
}

.range-container .label {
  font-weight: 600;
  font-size: 1rem;
  margin-bottom: 0.5rem;
  color: #333;
}

/* === Responsive === */
@media (max-width: 400px) {
  .tmatrix-modal-content-filter,
  .modal-content-filter {
    width: 90%;
    padding: 15px;
  }

  .modal-content-filter h3 {
    font-size: 18px;
  }
}
/* Layout: Title left, icons right */
.filter-header-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  margin-bottom: 16px;
}

/* Title styling */
.filter-title {
  font-size: 18px;
  font-weight: 600;
  color: #2d3748;
  margin: 0;
}

/* Icon group styling */
.icon-row {
  display: flex;
  gap: 16px;
  align-items: center;
}

/* Icon container */
.icon-wrapper {
  position: relative;
  cursor: pointer;
}

/* Icons */
.icon-clear {
  font-size: 20px;
  color: #0056b3;
  transition: transform 0.2s ease;
}

.icon-clear:hover {
  transform: scale(1.2);
}

/* Tooltip */
.icon-wrapper::after {
  content: attr(data-tooltip);
  position: absolute;
  bottom: -28px;
  left: 50%;
  transform: translateX(-50%);
  background-color: #2d3748;
  color: white;
  padding: 4px 8px;
  font-size: 12px;
  white-space: nowrap;
  border-radius: 4px;
  opacity: 0;
  pointer-events: none;
  transition: opacity 0.2s ease;
  z-index: 1;
}

.icon-wrapper:hover::after {
  opacity: 1;
}
`, "",{"version":3,"sources":["webpack://./src/Components/MainSection/FilterBox/FilterBox.css"],"names":[],"mappings":"AAAA,qBAAqB;AACrB;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,0BAA0B;AAC5B;;AAEA,0BAA0B;AAC1B;EACE,aAAa;EACb,sBAAsB;EACtB,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,0CAA0C;EAC1C,UAAU;EACV,gBAAgB;EAChB,kBAAkB;EAClB,kDAAkD;EAClD,kCAAkC;EAClC,UAAU;AACZ;;AAEA;EACE;IACE,UAAU;IACV,4BAA4B;EAC9B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA,wBAAwB;AACxB;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,mBAAmB;EACnB,mBAAmB;AACrB;;;;AAIA,oBAAoB;AACpB;EACE,yBAAyB;EACzB,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,2DAA2D;EAC3D,SAAO;EACP,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,2DAA2D;EAC3D,WAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA,mBAAmB;AACnB;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,SAAO;EACP,8CAA8C;AAChD;;AAEA;EACE,qBAAqB;EACrB,4CAA4C;AAC9C;;AAEA,mCAAmC;AACnC;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,aAAa;EACb,kBAAkB;EAClB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,qDAAqD;AACvD;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;AACpB;;AAEA,0BAA0B;AAC1B;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,eAAe;EACf,qBAAqB;EACrB,mBAAmB;EACnB,yBAAyB;EACzB,yCAAyC;EACzC,gBAAgB;EAChB,WAAW;EACX,mCAAmC;AACrC;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,qBAAqB;EACrB,WAAW;AACb;;AAEA,uBAAuB;AACvB;EACE;;IAEE,UAAU;IACV,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;AACF;AACA,oCAAoC;AACpC;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,WAAW;EACX,mBAAmB;AACrB;;AAEA,kBAAkB;AAClB;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;;AAEA,uBAAuB;AACvB;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA,mBAAmB;AACnB;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA,UAAU;AACV;EACE,eAAe;EACf,cAAc;EACd,+BAA+B;AACjC;;AAEA;EACE,qBAAqB;AACvB;;AAEA,YAAY;AACZ;EACE,2BAA2B;EAC3B,kBAAkB;EAClB,aAAa;EACb,SAAS;EACT,2BAA2B;EAC3B,yBAAyB;EACzB,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,kBAAkB;EAClB,UAAU;EACV,oBAAoB;EACpB,6BAA6B;EAC7B,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ","sourcesContent":["/* === Backdrop === */\n.tmatrix-modal-backdrop-filter {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.5);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 1000;\n  backdrop-filter: blur(6px);\n}\n\n/* === Modal Content === */\n.tmatrix-modal-content-filter {\n  display: flex;\n  flex-direction: column;\n  background-color: #ffffff;\n  padding: 32px;\n  border-radius: 12px;\n  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);\n  width: 90%;\n  max-width: 640px;\n  position: relative;\n  transition: transform 0.3s ease, opacity 0.3s ease;\n  animation: fadeIn 0.3s ease-in-out;\n  opacity: 1;\n}\n\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n    transform: translateY(-20px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n/* === Select List === */\n.list-select-filter {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 12px;\n  align-items: center;\n  margin-bottom: 20px;\n}\n\n\n\n/* === Buttons === */\n.button-close-filter {\n  background-color: #cbb9af;\n  color: #ffffff;\n  border: none;\n  padding: 12px 24px;\n  border-radius: 8px;\n  cursor: pointer;\n  font-size: 14px;\n  font-weight: 600;\n  transition: background-color 0.3s ease, transform 0.2s ease;\n  flex: 1;\n  text-align: center;\n}\n\n.button-close-filter:hover {\n  background-color: #a8907e;\n  transform: scale(1.05);\n}\n\n.button-add {\n  background-color: #94d3a2;\n  color: #fff;\n  border: none;\n  padding: 12px 24px;\n  border-radius: 8px;\n  cursor: pointer;\n  font-size: 14px;\n  font-weight: 600;\n  transition: background-color 0.3s ease, transform 0.2s ease;\n  flex: 0.5;\n  text-align: center;\n}\n\n.button-add:hover {\n  background-color: #7db88a;\n  transform: scale(1.05);\n}\n\n/* === Inputs === */\n.input-menu-filter {\n  width: 220px;\n  padding: 12px;\n  border: 1px solid #ccc;\n  border-radius: 6px;\n  font-size: 16px;\n  outline: none;\n  box-sizing: border-box;\n  flex: 2;\n  transition: border-color 0.3s, box-shadow 0.3s;\n}\n\n.input-menu-filter:focus {\n  border-color: #94d3a2;\n  box-shadow: 0 0 8px rgba(148, 211, 162, 0.4);\n}\n\n/* === Parameter List Section === */\n.modal-content-filter h3 {\n  font-size: 20px;\n  font-weight: 600;\n  margin-bottom: 15px;\n  color: #2d3748;\n}\n\n.modal-content-filter ul {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n  text-align: left;\n}\n\n.modal-content-filter li {\n  background: #f0f2f5;\n  padding: 10px;\n  margin: 6px 0;\n  border-radius: 6px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.modal-content-filter input[type=\"text\"] {\n  width: 48%;\n  padding: 8px;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n  font-size: 14px;\n  text-align: center;\n}\n\n.modal-content-filter button {\n  margin-top: 15px;\n  padding: 10px 15px;\n  background: #7490c7;\n  color: white;\n  border: none;\n  border-radius: 6px;\n  font-size: 14px;\n  cursor: pointer;\n  transition: background 0.3s ease, transform 0.2s ease;\n}\n\n.modal-content-filter button:hover {\n  background: #5d78a6;\n  transform: scale(1.05);\n}\n\n.modal-content-filter button:active {\n  background: #4b6088;\n  transform: scale(0.98);\n}\n\n.modal-content-filter button:not(:last-child) {\n  margin-right: 10px;\n}\n\n/* === Range Section === */\n.range-container {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n  padding: 1.2rem;\n  margin-bottom: 1.5rem;\n  border-radius: 10px;\n  background-color: #ffffff;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);\n  max-width: 400px;\n  width: 100%;\n  font-family: 'Segoe UI', sans-serif;\n}\n\n.range-container .label {\n  font-weight: 600;\n  font-size: 1rem;\n  margin-bottom: 0.5rem;\n  color: #333;\n}\n\n/* === Responsive === */\n@media (max-width: 400px) {\n  .tmatrix-modal-content-filter,\n  .modal-content-filter {\n    width: 90%;\n    padding: 15px;\n  }\n\n  .modal-content-filter h3 {\n    font-size: 18px;\n  }\n}\n/* Layout: Title left, icons right */\n.filter-header-row {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  width: 100%;\n  margin-bottom: 16px;\n}\n\n/* Title styling */\n.filter-title {\n  font-size: 18px;\n  font-weight: 600;\n  color: #2d3748;\n  margin: 0;\n}\n\n/* Icon group styling */\n.icon-row {\n  display: flex;\n  gap: 16px;\n  align-items: center;\n}\n\n/* Icon container */\n.icon-wrapper {\n  position: relative;\n  cursor: pointer;\n}\n\n/* Icons */\n.icon-clear {\n  font-size: 20px;\n  color: #0056b3;\n  transition: transform 0.2s ease;\n}\n\n.icon-clear:hover {\n  transform: scale(1.2);\n}\n\n/* Tooltip */\n.icon-wrapper::after {\n  content: attr(data-tooltip);\n  position: absolute;\n  bottom: -28px;\n  left: 50%;\n  transform: translateX(-50%);\n  background-color: #2d3748;\n  color: white;\n  padding: 4px 8px;\n  font-size: 12px;\n  white-space: nowrap;\n  border-radius: 4px;\n  opacity: 0;\n  pointer-events: none;\n  transition: opacity 0.2s ease;\n  z-index: 1;\n}\n\n.icon-wrapper:hover::after {\n  opacity: 1;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
